module.exports = __webpack_public_path__ + "static/media/loading.da6f6036.gif";